import React, { memo } from 'react';
import { StackNavigationProp, useNavigation } from '@betty/navigation';
import { Box, Button, Image, Text, Timer } from '@betty/moonlight';
import {
  LimitReachedBottomSheetProps,
  ReachedLimitTypes,
} from './LimitReachedBottomSheet.types';
import { getLimitExceededMessage } from './LimitReachedBottomSheet.utils';

function LimitReachedBottomSheet({
  type,
  period,
  resetDate,
}: LimitReachedBottomSheetProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  return (
    <Box alignItems="center">
      <Image
        name="common.LimitReachedClock"
        resizeMode="contain"
        width={100}
        height={100}
      />
      <Box width="100%" alignItems="center" gap="space-300">
        <Text
          variant="h3"
          color="darkSurfacePrimary"
          locNS="responsibleGaming"
          locKey="takeBreather"
        />
        <Text
          variant="body-m"
          locNS="responsibleGaming"
          locKey={getLimitExceededMessage(period, type)}
          color="darkSurfacePrimary"
          textAlign="center"
        />
        <Text
          variant="body-m"
          locNS="responsibleGaming"
          locKey={
            type === ReachedLimitTypes.Loss ? 'changeYourBet' : 'comeBackLater'
          }
          textAlign="center"
          color="darkSurfacePrimary"
        />
        <Button
          variant="primary"
          locNS="responsibleGaming"
          locKey={
            type === ReachedLimitTypes.Loss
              ? 'goToLossLimits'
              : 'goToPlaytimeLimits'
          }
          width="100%"
          onPress={() =>
            navigation.navigate(
              type === ReachedLimitTypes.Loss ? 'LossLimit' : 'PlaytimeLimit',
            )
          }
        />
        <Button
          variant="secondary"
          locNS="responsibleGaming"
          locKey="goToHome"
          width="100%"
          onPress={() =>
            navigation.navigate('MainTabNavigator', { screen: 'Home' })
          }
        />
        <Box display="flex" flexDirection="row" gap="space-100">
          <Image
            name="common.TimerClock"
            resizeMode="contain"
            width={20}
            height={20}
          />
          <Text
            variant="body-s"
            locNS="responsibleGaming"
            locKey="resetsIn"
            color="darkSurfacePrimary"
          />
          <Timer
            variant="body-s-semi"
            color="darkSurfacePrimary"
            time={resetDate}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(LimitReachedBottomSheet);
